import { Channel } from '../models';
import { ModelResource } from './resource';

export class Channels extends ModelResource<Channel> {
  model = Channel;

  resourcePath = 'v1/channels';
}
